module.exports = __webpack_public_path__ + "static/image-17e39ae86ed1c9b2f066503dce104f66.png";